import { MODULE_NAME } from '../constants';

export const GET_STATIC_INFO = `${MODULE_NAME}/GET_STATIC_INFO`;
export const GET_STATIC_INFO_SUCCESS = `${MODULE_NAME}/GET_STATIC_INFO_SUCCESS`;
export const GET_STATIC_INFO_ERROR = `${MODULE_NAME}/GET_STATIC_INFO_ERROR`;
